module.exports = __webpack_public_path__ + "res/28-img_button_bg.b591d630c9753ed61aff0ca51aa48503.png";